import React, { useState } from "react";
import Image from "next/image";
import classNames from "classnames";
import newsLang from "../../i18n/news";
import styles from "./PopupForm.module.scss";
import ReceiveNewsForm from "../News/ReceiveNewsForm";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import useBeforeunload from "hooks/useBeforeunload";
import { postRequest } from "actions/requests";
import Cookies from "js-cookie";

const PopupForm = ({ locale }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [setIsUnload] = useBeforeunload();
  const [visible, setVisible] = useState(false);

  const onSubmit = async (values, actions) => {
    const token = await executeRecaptcha("contact");
    values.lang_id = locale === "vi" ? 1 : 2;
    values.type = 3;
    if (token) {
      let msg = locale === "vi" ? "Đăng ký thành công" : "Register success";
      postRequest(values)
        .then(() => {
          setVisible(true);
          setIsUnload(false);
          Cookies.remove("isLeave");
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  };

  return (
    <div className={classNames("py-4 px-3 px-md-5", styles.popupForm)}>
      <div className="row d-flex align-items-center">
        <div className="d-none d-lg-block col-lg-5">
          <Image src="../static/img-popup-form.png" width={250} height={400} />
        </div>
        <div className="col-12 col-lg-7">
          {!visible && (
            <>
              <h4
                className={classNames(
                  "text-uppercase mb-3 font-weight-bold text-white text-center"
                )}
              >
                {newsLang.popupForm.title[locale]}
              </h4>
              <p
                className="text-center"
                dangerouslySetInnerHTML={{
                  __html: `${newsLang.popupForm.subTitle[locale]}`,
                }}
              />
              <ReceiveNewsForm
                email
                name
                phone
                position
                locale={locale}
                vertical
                btnClasses={styles.btnSubmit}
                onSubmit={onSubmit}
              />
            </>
          )}
          {visible && (
            <>
              <h4 className="text-center text-white">
                Cảm ơn bạn <br /> đã đăng ký nhận tài liệu
              </h4>
              <p className="text-center">
                Case Study sẽ được gửi về Email đã đăng ký. Đừng quên kiểm tra
                Email bạn nhé!
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupForm;
